module.exports = __webpack_public_path__ + "img/handraw_blog.31b9009e.svg";